// Version: 1.0 - Services Section Component
import React from 'react';
import './Services.css';

const Services: React.FC = () => {
  const services = [
    {
      icon: 'fa-syringe',
      title: 'IV Medication Therapy',
      description: 'Rapid intravenous treatments designed to break severe migraine and headache cycles.',
      highlight: 'Conceptual Service'
    },
    {
      icon: 'fa-brain',
      title: 'Nerve Block Procedures',
      description: 'Targeted nerve blocks for immediate relief of certain headache types.',
      highlight: 'Conceptual Service'
    },
    {
      icon: 'fa-stethoscope',
      title: 'Specialist Evaluation',
      description: 'Immediate assessment by headache medicine specialists who understand complex cases.',
      highlight: 'Conceptual Service'
    },
    {
      icon: 'fa-heartbeat',
      title: 'Monitoring & Observation',
      description: 'Careful monitoring during and after treatment to ensure safety and effectiveness.',
      highlight: 'Conceptual Service'
    },
    {
      icon: 'fa-clipboard-list',
      title: 'Treatment Planning',
      description: 'Development of follow-up care plans and coordination with ongoing headache specialists.',
      highlight: 'Conceptual Service'
    },
    {
      icon: 'fa-ambulance',
      title: 'Emergency Triage',
      description: 'Rapid assessment to identify serious conditions requiring immediate intervention.',
      highlight: 'Conceptual Service'
    }
  ];

  return (
    <section id="services" className="services">
      <div className="container">
        <div className="section-header">
          <h2>Envisioned Services</h2>
          <p>
            What a dedicated headache emergency center could offer—specialized treatments 
            designed specifically for severe headache conditions.
          </p>
        </div>

        <div className="concept-notice">
          <i className="fa fa-lightbulb"></i>
          <span>
            <strong>Note:</strong> These services represent a conceptual vision. 
            For current headache treatment, please consult with your healthcare provider or visit{' '}
            <a href="https://www.headacheMD.org" target="_blank" rel="noopener noreferrer">
              headacheMD.org
            </a>
          </span>
        </div>

        <div className="services-grid">
          {services.map((service, index) => (
            <div key={index} className="service-card">
              <div className="service-icon">
                <i className={`fa ${service.icon}`}></i>
              </div>
              <div className="service-content">
                <h3>{service.title}</h3>
                <p>{service.description}</p>
                <span className="service-highlight">{service.highlight}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
